import cn from 'classnames';
import { Tile } from '@creditflowresearch/uilib/Tile';
import Button from '@creditflowresearch/uilib/Button';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import DataTable, { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import RoadshowsTileProvider, {
  useRoadshowsTileContext,
} from '@/creditflowresearch/application/Roadshows/RoadshowsTileContext';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import RoadshowsTileHeader from './RoadshowsTileHeader';
import columns from './columns';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import styles from './roadshowsTile.module.scss';

const RoadshowsTile = () => {
  const { collection, isMore, loadMore, isFetching, isHideTile } = useRoadshowsTileContext();

  if (isHideTile) {
    return null;
  }

  return (
    <Tile dataTest="roadshowsTile" className={ spacesStyles.mtl }>
      <RoadshowsTileHeader />
      <DataTable
        dataTest="roadshowsTileTable"
        columns={ columns }
        data={ collection }
        isHeaderVisible={ false }
        className={ cn(dataTableStyles.isHoverable, styles.tableOverride) }
        rowClassNameCallback={ () => styles.row }
        loadingComponent={ Spinner }
        isFetching={ isFetching }
      />
      { isMore && (
        <Button
          variant="text"
          size="S"
          className={ styles.moreButton }
          onClick={ loadMore }
          dataTest="roadshowsTileButtonMore"
        >
          More
        </Button>
      ) }
    </Tile>
  );
};

const RoadshowsTileWithProvider = () => {
  const { roadshowsTileData } = useParentPageContext();

  return (
    <RoadshowsTileProvider { ...roadshowsTileData }>
      <RoadshowsTile />
    </RoadshowsTileProvider>
  );
};

export default RoadshowsTileWithProvider;
